import React from "react";
import { FormattedMessage } from "react-intl";

//
function BankDetailsDepositContent(
  props: Record<string, any>
): React.ReactElement<React.ComponentProps<any>, any> {
  return (
    <React.Fragment>
      <div className="bank-details__service-name">SWIFT</div>
      <FormattedMessage tagName="span" id="cashier-bankdetailsAccountName" />
      <FormattedMessage
        tagName="span"
        id={`cashier-bankdetailsAccountIBAN-${props.user["currencyCode"]}`}
      />
      <FormattedMessage
        tagName="span"
        id={`cashier-bankdetailsAccountNumber-${props.user["currencyCode"]}`}
      />
      <FormattedMessage tagName="span" id="cashier-bankdetailsAccountSwift" />
      <FormattedMessage
        tagName="span"
        id="cashier-bankdetailsAccountSortCode"
      />
      <div className="bank-details__footer">
        <FormattedMessage
          tagName="span"
          id={`cashier-bankdetailsAccountIntSwift-${props.user["currencyCode"]}`}
        />
        <FormattedMessage tagName="span" id="cashier-bankdetailsName" />
        <FormattedMessage tagName="span" id="cashier-bankdetailsAddress" />
      </div>
      {props.user["currencyCode"] === "EUR" && (
        <React.Fragment>
          <div className="bank-details__service-name">SEPA</div>
          <FormattedMessage
            tagName="span"
            id="cashier-bankdetailsAccountName"
          />
          <FormattedMessage
            tagName="span"
            id="cashier-bankdetailsAccountSepaIBAN"
          />
          <FormattedMessage
            tagName="span"
            id="cashier-bankdetailsAccountSepaBankName"
          />
          <FormattedMessage
            tagName="span"
            id="cashier-bankdetailsAccountSepaBankAddress"
          />
        </React.Fragment>
      )}
    </React.Fragment>
  );
}

export default BankDetailsDepositContent;
